<template>
  <div class="modal-astron d-flex flex-column gap-4">
    <snow-select
      v-model="form.product_id"
      id="product-select"
      label="Produto"
      :disabled="isEdit"
      :errors="errors.product_id"
      :options="products.map(({ id, name }) => ({ id, name }))"
      required
    />
    <snow-input
      v-model="form.description"
      id="description"
      label="Descrição da integração (Opcional)"
    />
    <snow-input
      v-model="form.url"
      id="url"
      label="URL para webhook da Astron Members"
      :rules="rules.url"
      required
    />

    <div class="snow-submit-buttons">
      <snow-button
        size="lg"
        class="order-lg-0 order-1"
        variant="gray"
        text="Cancelar"
        @click="$emit('close')"
      />
      <snow-button
        size="lg"
        :text="isEdit ? 'Salvar' : 'Integrar'"
        :loading="loading"
        :disabled="!isValid"
        @click="submit"
      />
    </div>
  </div>
</template>
<script>
import { formFields } from "@/functions/helpers";
import IntegrationModalMixin from "@/mixins/integrationModal";
import { required, validUrl } from "@/functions/validation";
export default {
  mixins: [IntegrationModalMixin],
  data() {
    return {
      ...formFields(["product_id", "url", "status", "description"], {
        ...this.integrationToEdit,
        product_id: this.integrationToEdit?.product?.id
      })
    };
  },
  methods: {
    submit() {
      this.loading = true;

      let data = {
        ...this.form
      };
      let action = "integration/postIntegration";

      if (this.isEdit) {
        data.id = this.integrationToEdit.id;
      } else {
        data.status = true;
      }

      this.$store
        .dispatch(action, data)
        .then(() => {
          this.$emit("close");
          this.$message.success("A integração foi salva!");
          this.$emit("update-list");
        })
        .catch(error => {
          this.$message.error(
            error.response?.data.message || "Erro ao salvar integração."
          );
          this.errors = error.response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    isValid() {
      return this.form.product_id && this.form.url;
    },
    rules() {
      return {
        url: [required(), validUrl()]
      };
    }
  }
};
</script>
